import api from "./axios";
import { ApiPaginationResponse, ApiResponse } from "@/types/apiResponse";
import { BlogApiItem, BlogCardItem, BlogDetail } from "@/types/blogs";

export async function fetchBlogs(
  tagId?: number | null
): Promise<ApiPaginationResponse<BlogCardItem[]>> {
  const res = await api.get<ApiPaginationResponse<BlogApiItem[]>>("/blogs", {
    params: tagId ? { tag_id: tagId } : {},
  });

  const blogs: BlogCardItem[] = convertApiBlogsObjects(res.data.data);

  return {
    data: blogs,
    links: res.data.links,
  };
}

export async function fetchBlogDetail(blogId: string): Promise<BlogDetail> {
  const res = await api.get<ApiResponse<BlogDetail>>(`/blogs/${blogId}`);

  return res.data.data;
}

export async function fetchBlogsNextPage(
  nextPageUrl: string
): Promise<ApiPaginationResponse<BlogCardItem[]>> {
  const res = await api.get<ApiPaginationResponse<BlogApiItem[]>>(nextPageUrl);

  const blogs: BlogCardItem[] = convertApiBlogsObjects(res.data.data);

  return {
    data: blogs,
    links: res.data.links,
  };
}

export async function fetchSearchBlogs(search: string) {
  const res = await api.get<ApiPaginationResponse<BlogApiItem[]>>("/blogs", {
    params: { search: search },
  });

  const blogs: BlogCardItem[] = convertApiBlogsObjects(res.data.data);

  return {
    data: blogs,
    links: res.data.links,
  };
}

function convertApiBlogsObjects(apiBlogList: BlogApiItem[]): BlogCardItem[] {
  return apiBlogList.map((blog) => ({
    id: blog.id,
    cardImageUrl: blog.card_image_url,
    createdAt: blog.created_at,
    tags: blog.tags,
    titles: blog.titles,
    shortDescriptions: blog.short_descriptions,
  }));
}
